/**
 * Fixture for the agents widget — shape of list_agents's structured
 * output (mcp/server.ts listAgentsTool): agent rows with machine name,
 * warm flag, live session status, and phase-9 model/effort defaults.
 */
import { LIVE_SESSION_ID, MACHINES } from "./seed";

export function agentsFixture(): Record<string, unknown> {
  return {
    agents: [
      {
        agentName: "email-triage",
        description:
          "Sweeps the inbox overnight — flags urgent mail, drafts replies, " +
          "files the rest.",
        machineId: MACHINES.mini.machineId,
        machineName: MACHINES.mini.name,
        cwd: "~/agents/email-triage",
        warm: true,
        activeSessionId: LIVE_SESSION_ID,
        sessionStatus: "running",
        defaultModel: null,
        defaultEffort: null,
      },
      {
        agentName: "health-sync",
        description:
          "Pulls wearable data nightly and keeps the health log current.",
        machineId: MACHINES.air.machineId,
        machineName: MACHINES.air.name,
        cwd: "~/agents/health-sync",
        warm: false,
        activeSessionId: null,
        sessionStatus: null,
        defaultModel: "haiku",
        defaultEffort: "low",
      },
      {
        agentName: "morning-brief",
        description:
          "Compiles the sunrise digest: overnight runs, calendar, and what " +
          "needs you.",
        machineId: MACHINES.mini.machineId,
        machineName: MACHINES.mini.name,
        cwd: "~/agents/morning-brief",
        warm: true,
        activeSessionId: null,
        sessionStatus: null,
        defaultModel: null,
        defaultEffort: "medium",
      },
    ],
    teamRef: null,
  };
}
